import { useContext } from 'react';

import { NectarAnalyticsContext } from '~/context/NectarAnalyticsContext';

import type { UseNectarAnalyticsReturn } from './useNectarAnalytics';

export const useNectarAnalyticsContext = (): UseNectarAnalyticsReturn => {
  const context = useContext(NectarAnalyticsContext);
  if (!context) {
    throw new Error('useNectarAnalyticsContext must be used within a NectarAnalyticsProvider');
  }
  return context;
};
